var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bee41a65a3d4e1bcb57f673b6c0bedbea752e4d9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"bee41a65a3d4e1bcb57f673b6c0bedbea752e4d9"};
      